module.exports = __webpack_public_path__ + "static/media/assistance_on_road.382a0121.svg";